import { IBaseAction, IPromiseParam } from '../base';
import * as types from './actionTypes.testMode';
import Node from '../../classes/Node';
import { Environment } from '../../const/environment';

export interface IConnectTestCasesParam {
    projectId: string,
    environment: Environment
    node: Node
}

export const connectTestCases = ({ projectId, environment, node }: IConnectTestCasesParam):
    IConnectTestCasesParam & IBaseAction => ({
        type: types.CONNECT_TEST_CASES_REQ,
        projectId,
        environment,
        node
    });

export interface IDisconnectTestCasesParam {
    node: Node
}
export const disconnectTestCases = ({ node }: IDisconnectTestCasesParam) => ({
    type: types.DISCONNECT_TEST_CASES_REQ,
    node
});

export interface IGetDialogContentParam extends IPromiseParam {
    conversationId: string,
}

export const getDialogsContent =
    ({ conversationId, resolve, reject }
        : IGetDialogContentParam)
        : IGetDialogContentParam & IBaseAction => ({
            type: types.GET_DIALOGS_CONTENT_REQ,
            conversationId,
            resolve,
            reject
        });

export interface IAddTextParam extends IPromiseParam {
    conversationId: string,
    text: string,
    dialog: Node,
    dialogTree: Node,
    curNode: Node,
    direction: string,
}

export const addText = ({ text, conversationId, dialog, dialogTree, direction, curNode, resolve, reject }
    : IAddTextParam)
    : IAddTextParam & IBaseAction => ({
        type: types.ADD_TEXT_DIALOG_ITEM_REQ,
        text,
        conversationId,
        dialog,
        dialogTree,
        direction,
        curNode,
        resolve,
        reject
    });

export interface IUpdateTextParam extends IPromiseParam {
    conversationId: string,
    text: string,
    dialogTree: Node,
    curNode: Node,
}
export const updateText = ({ text, conversationId, dialogTree, curNode, resolve, reject }
    : IUpdateTextParam)
    : IUpdateTextParam & IBaseAction => ({
        type: types.UPDATE_TEXT_DIALOG_ITEM_REQ,
        text,
        conversationId,
        dialogTree,
        curNode,
        resolve,
        reject
    });

export interface IAddVisualStateParam extends IPromiseParam {
    conversationId: string,
    direction: string,
    visualState: any,
    dialogTree: Node,
    curNode: Node,
    dialog: Node,
}
export const addVisualState = ({ visualState, conversationId, curNode, dialog, dialogTree, direction, resolve, reject }
    : IAddVisualStateParam)
    : IAddVisualStateParam & IBaseAction => ({
        type: types.ADD_VISUAL_STATE_DIALOG_ITEM_REQ,
        visualState,
        conversationId,
        curNode,
        dialog,
        dialogTree,
        direction,
        resolve,
        reject
    });

export interface IUpdateVisualStateParam extends IPromiseParam {
    conversationId: string,
    visualState: any,
    dialogTree: Node,
    curNode: Node,
}
export const updateVisualState = ({ visualState, conversationId, dialogTree, curNode, resolve, reject }
    : IUpdateVisualStateParam)
    : IUpdateVisualStateParam & IBaseAction => ({
        type: types.UPDATE_VISUAL_STATE_DIALOG_ITEM_REQ,
        visualState,
        conversationId,
        dialogTree,
        curNode,
        resolve,
        reject
    });

export interface IAddDialogItemFromSystemMessageParam extends IPromiseParam {
    text: string,
    category: string,
    reqId: string,
    meta: any,
    data: any,
    conversationId: string,
    dialog: Node,
    dialogTree: Node,
}
export const addDialogItemFromSystemMessage = ({ text, category, reqId, meta, data, conversationId, dialog, dialogTree, resolve, reject }
    : IAddDialogItemFromSystemMessageParam)
    : IAddDialogItemFromSystemMessageParam & IBaseAction => ({
        type: types.ADD_DIALOG_ITEM_FROM_SYSTEM_MSG_REQ,
        text,
        category,
        data,
        meta,
        conversationId,
        dialog,
        dialogTree,
        reqId,
        resolve,
        reject
    });

export interface IAddDialogItemWithQrCodeParam {
    message: any,
}

export const addDialogItemWithQrCode = ({ message }
    : IAddDialogItemWithQrCodeParam)
    : IAddDialogItemWithQrCodeParam & IBaseAction => ({
        type: types.ADD_DIALOG_ITEM_WITH_QR_CODE_REQ,
        message
    });

export interface IDeleteDialogItemParam extends IPromiseParam {
    conversationId: string,
    node: Node,
    dialogTree: Node,
}

export const deleteDialogItem = ({ conversationId, dialogTree, node, resolve, reject }
    : IDeleteDialogItemParam)
    : IDeleteDialogItemParam & IBaseAction => ({
        type: types.DELETE_DIALOG_ITEM_REQ,
        conversationId,
        dialogTree,
        node,
        resolve,
        reject
    });

export interface IAddDialogParam extends IPromiseParam {
    conversationId: string,
    dialogTree: Node,
}

export const addDialog = ({ conversationId, dialogTree, resolve, reject }
    : IAddDialogParam)
    : IAddDialogParam & IBaseAction => ({
        type: types.ADD_DIALOG_REQ,
        conversationId,
        dialogTree,
        resolve,
        reject
    });

export interface ICopyDialogParam extends IPromiseParam {
    conversationId: string,
    dialogTree: Node,
    node: Node,
}

export const copyDialog = ({ conversationId, dialogTree, node, resolve, reject }
    : ICopyDialogParam)
    : ICopyDialogParam & IBaseAction => ({
        type: types.COPY_DIALOG_REQ,
        conversationId,
        dialogTree,
        node,
        resolve,
        reject
    });

export interface IPasteDialogParam extends IPromiseParam {
    conversationId: string,
    dialogTree: Node,
    phrases: Node[],
}

export const pasteDialog = ({ conversationId, dialogTree, phrases, resolve, reject }
    : IPasteDialogParam)
    : IPasteDialogParam & IBaseAction => ({
        type: types.PASTE_DIALOG_REQ,
        conversationId,
        dialogTree,
        phrases,
        resolve,
        reject
    });

export interface IDeleteDialogParam extends IPromiseParam {
    conversationId: string,
    dialogTree: Node,
    node: Node,
}

export const deleteDialog = ({ conversationId, dialogTree, node, resolve, reject }
    : IDeleteDialogParam)
    : IDeleteDialogParam & IBaseAction => ({
        type: types.DELETE_DIALOG_REQ,
        conversationId,
        dialogTree,
        node,
        resolve,
        reject
    });

export interface IChangeDialogOrderParam extends IPromiseParam {
    conversationId: string,
    dialogTree: Node,
    addedIndex: number,
    removedIndex: number,
}
export const changeDialogOrder = ({ conversationId, dialogTree, addedIndex, removedIndex, resolve, reject }
    : IChangeDialogOrderParam)
    : IChangeDialogOrderParam & IBaseAction => ({
        type: types.CHANGE_DIALOG_ORDER_REQ,
        conversationId,
        dialogTree,
        addedIndex,
        removedIndex,
        resolve,
        reject
    });

export interface IAddExpectedResponseParam extends IPromiseParam {
    conversationId: string,
    dialogTree: Node,
    node: Node,
    response: string,
}
export const addExpectedResponse = ({ conversationId, dialogTree, node, response, resolve, reject }
    : IAddExpectedResponseParam)
    : IAddExpectedResponseParam & IBaseAction => ({
        type: types.ADD_EXPECTED_RESPONSE_REQ,
        conversationId,
        dialogTree,
        node,
        response,
        resolve,
        reject
    });

export interface ICopyAllExpectedResponsesParam extends IPromiseParam {
    node: Node,
}
export const copyAllExpectedResponses = ({ node, resolve, reject }
    : ICopyAllExpectedResponsesParam)
    : ICopyAllExpectedResponsesParam & IBaseAction => ({
        type: types.COPY_EXPECTED_RESPONSE_REQ,
        node,
        resolve,
        reject
    });

export interface IPasteAllExpectedResponsesParam extends IPromiseParam {
    conversationId: string,
    dialogTree: Node,
    node: Node,
    copiedExpectedResponses: any,
}
export const pasteAllExpectedResponses = ({ conversationId, dialogTree, node, copiedExpectedResponses, resolve, reject }
    : IPasteAllExpectedResponsesParam)
    : IPasteAllExpectedResponsesParam & IBaseAction => ({
        type: types.PASTE_EXPECTED_RESPONSE_REQ,
        conversationId,
        dialogTree,
        node,
        copiedExpectedResponses,
        resolve,
        reject
    });

export interface IEditExpectedResponseParam extends IPromiseParam {
    conversationId: string,
    dialogTree: Node,
    node: Node,
    response: string,
}
export const editExpectedResponse = ({ conversationId, dialogTree, node, response, resolve, reject }
    : IEditExpectedResponseParam)
    : IEditExpectedResponseParam & IBaseAction => ({
        type: types.EDIT_EXPECTED_RESPONSE_REQ,
        conversationId,
        dialogTree,
        node,
        response,
        resolve,
        reject
    });

export interface IDeleteExpectedResponseParam extends IPromiseParam {
    conversationId: string,
    dialogTree: Node,
    node: Node,
    response: string,
}
export const deleteExpectedResponse = ({ conversationId, dialogTree, node, response, resolve, reject }
    : IDeleteExpectedResponseParam)
    : IDeleteExpectedResponseParam & IBaseAction => ({
        type: types.DELETE_EXPECTED_RESPONSE_REQ,
        conversationId,
        dialogTree,
        node,
        response,
        resolve,
        reject
    });

export interface IDeleteAllExpectedResponsesParam extends IPromiseParam {
    conversationId: string,
    dialogTree: Node,
    node: Node,
}
export const deleteAllExpectedResponses = ({ conversationId, dialogTree, node, resolve, reject }
    : IDeleteAllExpectedResponsesParam)
    : IDeleteAllExpectedResponsesParam & IBaseAction => ({
        type: types.DELETE_ALL_EXPECTED_RESPONSES_REQ,
        conversationId,
        dialogTree,
        node,
        resolve,
        reject
    });

export interface IRefreshPhrasesParam extends IPromiseParam {
    conversationId: string,
    dialogTree: Node,
    node: Node,
    resetDialogContext: boolean
    keepRefreshCounter?: boolean
}
export const refreshPhrases = ({ conversationId, dialogTree, node, resetDialogContext, resolve, reject }
    : IRefreshPhrasesParam)
    : IRefreshPhrasesParam & IBaseAction => ({
        type: types.REFRESH_PHRASES_REQ,
        conversationId,
        dialogTree,
        node,
        resetDialogContext,
        resolve,
        reject
    });

export const stopRefreshPhrases = ()
    : IBaseAction => ({
        type: types.STOP_REFRESHING_ONE_DIALOG_REQ,
    });

export interface IRefreshDialogParam extends IPromiseParam {
    conversationId: string,
}
export const runDialog = ({ conversationId, resolve, reject }
    : IRefreshDialogParam)
    : IRefreshDialogParam & IBaseAction => ({
        type: types.REFRESH_DIALOGS_IN_CONVERSATION_REQ,
        conversationId,
        resolve,
        reject
    });

export const stopDialog = () => ({
    type: types.STOP_REFRESHING_DIALOG_REQ,
});

export interface IRefreshAllDialogsParam extends IPromiseParam {
}
export const runAllDialogs = ({ resolve, reject }
    : IRefreshAllDialogsParam)
    : IRefreshAllDialogsParam & IBaseAction => ({
        type: types.REFRESH_ALL_DIALOGS_REQ,
        resolve,
        reject
    });

export const stopRunningDialogs = () => ({
    type: types.STOP_REFRESHING_ALL_DIALOGS_REQ,
});

export const updateDialogContent = ({ phrases, curPhrase, projectId, conversationId, resolve, reject }) => ({
    type: types.UPDATE_DIALOG_CONTENT_REQ,
    phrases,
    curPhrase,
    projectId,
    conversationId,
    resolve,
    reject
});

export const showExpectedResponses = () => ({
    type: types.SHOW_EXPECTED_RESPONSES_REQ,
});

export const hideExpectedResponses = () => ({
    type: types.HIDE_EXPECTED_RESPONSES_REQ,
});

export const showCommandsInTestMode = () => ({
    type: types.SHOW_COMMANDS_IN_TEST_MODE_REQ,
});

export const hideCommandsInTestMode = () => ({
    type: types.HIDE_COMMANDS_IN_TEST_MODE_REQ,
});

export const showExpectedResponsesForDialogItem = ({ id }) => ({
    type: types.SHOW_EXPECTED_RESPONSES_FOR_DIALOG_ITEM_REQ,
    id
});

export const showCodeLinks = () => ({
    type: types.SHOW_CODE_LINKS_REQ,
});

export const hideCodeLinks = () => ({
    type: types.HIDE_CODE_LINKS_REQ,
});

export const connectQrCodeToTestDialog = ({ id }) => ({
    type: types.CONNECT_QR_CODE_TO_TEST_DIALOG_REQ,
    id
});

export const hideQrCodePopup = () => ({
    type: types.HIDE_QR_CODE_POPUP_REQ,
});

export const stopAudioInTestMode = () => ({
    type: types.STOP_AUDIO_IN_TEST_MODE_REQ,
});

export const generateQrCode = ({ resolve, reject }
    : IPromiseParam)
    : IPromiseParam & IBaseAction => ({
        type: types.GENERATE_QR_CODE_REQ,
        resolve,
        reject
    });
